import { action, atom } from "@reatom/framework";
import { BuyerOrderFilterType } from "definitions/poizon-api";
import { withDebounce } from "src/common/pipes";

import { OrderFilterStatus } from "../../widgets/PoizonOrderFilterWidget/PoizonOrderList.contants";
import { loadMoreOrderList } from "../fetchers/getPoizonBuyerOrderList";
import { clearOrderListAction } from "./orderList";

export interface PoizonFilterFormProps {
  type?: BuyerOrderFilterType;
  keyword?: string | undefined;
}

export const poizonFilterAtom = atom<PoizonFilterFormProps>(
  { type: OrderFilterStatus.ALL },
  "poizonFilterAtom",
);

poizonFilterAtom.onChange((ctx) => {
  clearOrderListAction(ctx);
  loadMoreOrderList(ctx);
});

export const setPoizonFilterAtom = action(
  (ctx, newValue: PoizonFilterFormProps) =>
    poizonFilterAtom(ctx, { ...ctx.get(poizonFilterAtom), ...newValue }),
  "setPoizonFilterAtom",
);

export const setPoizonFilterWithDebounceAction = setPoizonFilterAtom.pipe(
  withDebounce(600),
);
